import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Trash2, MailOpen, Mail } from "lucide-react";
import { api, get } from "@/lib/api";

export const AdminMessages = () => {
  const qc = useQueryClient();
  const { data = [], isLoading } = useQuery({ queryKey: ["admin-messages"], queryFn: () => get("/admin/messages") });
  const refresh = () => { qc.invalidateQueries({ queryKey: ["admin-messages"] }); qc.invalidateQueries({ queryKey: ["admin-stats"] }); };
  const mark = async (m) => { await api.patch(`/admin/messages/${m.id}`, null, { params: { read: !m.read } }); refresh(); };
  const del = async (m) => { if (window.confirm("Delete this message?")) { await api.delete(`/admin/messages/${m.id}`); refresh(); } };
  if (isLoading) return <p className="text-slate-600">Loading…</p>;
  if (!data.length) return <p className="text-slate-600" data-testid="admin-messages-empty">No messages yet.</p>;
  return (
    <div className="space-y-3" data-testid="admin-messages-list">
      {data.map((m) => (
        <div key={m.id} className={`rounded-2xl border bg-white p-5 ${m.read ? "border-[#E2E8F0]" : "border-[#03A896]"}`} data-testid={`admin-message-${m.id}`}>
          <div className="flex flex-wrap justify-between gap-3">
            <div>
              <p className="font-semibold text-[#0B2150]">{m.subject} {!m.read && <span className="ml-2 rounded-full bg-[#E6F4F1] px-2 py-0.5 text-xs text-[#027A6D]">New</span>}</p>
              <p className="text-xs text-slate-500 mt-1">{m.name} · <a href={`mailto:${m.email}`} className="underline">{m.email}</a> {m.phone && `· ${m.phone}`} · {new Date(m.created_at).toLocaleString()}</p>
            </div>
            <div className="flex gap-1">
              <button onClick={() => mark(m)} aria-label={m.read ? "Mark unread" : "Mark read"} className="p-2 rounded-full hover:bg-slate-100" data-testid={`admin-message-toggle-${m.id}`}>{m.read ? <Mail className="h-4 w-4" /> : <MailOpen className="h-4 w-4" />}</button>
              <button onClick={() => del(m)} aria-label="Delete message" className="p-2 rounded-full hover:bg-red-50 text-red-700" data-testid={`admin-message-delete-${m.id}`}><Trash2 className="h-4 w-4" /></button>
            </div>
          </div>
          <p className="mt-3 text-sm text-[#334155] whitespace-pre-wrap">{m.message}</p>
        </div>
      ))}
    </div>
  );
};
